import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdminDetails } from "../../slices/thunks";
import { createSelector } from "reselect";
import UserDetailsModal from "../../Components/Common/UserDetailsModal";

const UserDetails = ({ id, isOpen, onClose }) => {
  const dispatch = useDispatch();

  const selectUserDetailsState = (state) => state;
  const userDetailsSelector = createSelector(
    selectUserDetailsState,
    (state) => ({
      user: state.Admin.selectedAdmin,
      loading: state.Admin.loading,
      error: state.Admin.error,
    })
  );

  const { user, loading, error } = useSelector(userDetailsSelector);

  useEffect(() => {
    if (id && isOpen) {
      dispatch(fetchAdminDetails(id));
    }
  }, [dispatch, id, isOpen]);

  document.title = "User Details";

  return (
    <UserDetailsModal
      isOpen={isOpen}
      toggle={onClose}
      user={user}
      loading={loading}
      error={error}
    />
  );
};

export default UserDetails;
